import store from '@ps/store'
import _ from 'lodash'
import gameIframe from '@ps/bridge/iframe/iframe'
import { AstEventItem } from '@ps/bridge/qc/scripts/editor'
import qc from 'qc'
import { scripts } from '@ps/bridge/qc/scripts'
import { toQcColor } from '@ps/bridge/qc/color'
import { Event, EventBus } from '@ps/utils/event-bus'
export enum DrawLineType {
  /** 连线 */
  CONNECT_LINE = 'connectLine',
  /** 自由画线 */
  FREE_LINE = 'freeLine',
}
export type areaItem = {
  name: string
  lineColor: string
  lineSize: string
}
export type pairItem = {
  uuid: string
  name: string
  nameEn: string
  startArea: string
  endArea: string[]
  notAllowLineAgain: boolean
  lineColor: string
  lineSize: string
}
export type addPairsDataValue = {
  newValue: null
  oldValue: pairItem[]
}
export type removePairsDataValue = {
  newValue: {
    uuid: string
  }
  oldValue: {
    pair: pairItem[]
    ast: AstEventItem[]
  }
}
export type pairsDataValue = {
  newValue: {
    pairData: pairItem
  }
  oldValue: pairItem[]
}
export type applyToOtherValue = {
  newValue: {
    name: string
  }
  oldValue: pairItem[]
}
export type areasDataValue = {
  newValue: {
    areaData: areaItem
  }
  oldValue: areaItem[]
}

export const getAddPairDataAction = (value: addPairsDataValue) => {
  return {
    execute: ({ newValue }: addPairsDataValue) => {
      const cloneData = _.cloneDeep(
        store.state.workspace.game.drawLine.pairsData,
      )
      const data = {
        uuid: gameIframe.qcGame.math.uuid(),
        name: '配对' + (cloneData.length + 1),
        nameEn: 'Pair' + (cloneData.length + 1),
        startArea: '',
        endArea: [],
        notAllowLineAgain: true,
      }
      const ansData = [...cloneData, data]
      store.commit('workspace/game/drawLine/updatePairsData', {
        pairsData: ansData,
      })
    },
    undo: ({ oldValue }: addPairsDataValue) => {
      store.commit('workspace/game/drawLine/updatePairsData', {
        pairsData: _.cloneDeep(oldValue),
      })
    },
    value,
    methodName: 'getAddPairDataAction',
  }
}

export const getRemovePairDataAction = (value: removePairsDataValue) => {
  return {
    execute: ({ newValue }: removePairsDataValue) => {
      const cloneData = _.cloneDeep(
        store.state.workspace.game.drawLine.pairsData,
      )
      const ansData = cloneData.filter(
        (item: pairItem) => item.uuid !== newValue.uuid,
      )
      store.commit('workspace/game/drawLine/updatePairsData', {
        pairsData: ansData,
      })
      store.dispatch('workspace/game/visualProgram/removePairDataForEvent', {
        uuid: newValue.uuid,
      })
    },
    undo: ({ oldValue }: removePairsDataValue) => {
      store.commit('workspace/game/drawLine/updatePairsData', {
        pairsData: _.cloneDeep(oldValue.pair),
      })
      store.dispatch('workspace/game/visualProgram/saveAST', {
        ast: oldValue.ast,
      })
    },
    value,
    methodName: 'getRemovePairDataAction',
  }
}

export const getUpdatePairsDataAction = (value: pairsDataValue) => {
  return {
    execute: ({ newValue }: pairsDataValue) => {
      const cloneData = _.cloneDeep(
        store.state.workspace.game.drawLine.pairsData,
      )
      cloneData.forEach((pair: pairItem) => {
        const pairData = newValue.pairData
        if (pair.uuid === pairData.uuid) {
          pair.startArea = pairData.startArea
          pair.name = pairData.name
          pair.nameEn = pairData.nameEn
          pair.endArea = pairData.endArea
          pair.notAllowLineAgain = pairData.notAllowLineAgain
        }
      })
      store.commit('workspace/game/drawLine/updatePairsData', {
        pairsData: cloneData,
      })
    },
    undo: ({ oldValue }: pairsDataValue) => {
      store.commit('workspace/game/drawLine/updatePairsData', {
        pairsData: _.cloneDeep(oldValue),
      })
    },
    value,
    methodName: 'getUpdatePairsDataAction',
  }
}

export const getApplyToOtherAction = (value: applyToOtherValue) => {
  return {
    execute: ({ newValue }: applyToOtherValue) => {
      const cloneData = _.cloneDeep(
        store.state.workspace.game.drawLine.areasData,
      )
      const areaData = cloneData.find(
        (item: areaItem) => item.name === newValue.name,
      )
      cloneData.forEach((item: areaItem) => {
        item.lineColor = areaData.lineColor
        item.lineSize = areaData.lineSize
      })
      store.commit('workspace/game/drawLine/updateAreasData', {
        areasData: cloneData,
      })
    },
    undo: ({ oldValue }: applyToOtherValue) => {
      store.commit('workspace/game/drawLine/updateAreasData', {
        areasData: _.cloneDeep(oldValue),
      })
    },
    value,
    methodName: 'getApplyToOtherAction',
  }
}

export const getUpdateAreasDataAction = (value: areasDataValue) => {
  return {
    execute: ({ newValue }: areasDataValue) => {
      const cloneData = _.cloneDeep(
        store.state.workspace.game.drawLine.areasData,
      )
      cloneData.forEach((pair: areaItem) => {
        const pairData = newValue.areaData
        if (pair.name === pairData.name) {
          pair.lineColor = pairData.lineColor
          pair.lineSize = pairData.lineSize
        }
      })
      store.commit('workspace/game/drawLine/updateAreasData', {
        areasData: cloneData,
      })
    },
    undo: ({ oldValue }: areasDataValue) => {
      store.commit('workspace/game/drawLine/updateAreasData', {
        areasData: _.cloneDeep(oldValue),
      })
    },
    value,
    methodName: 'getUpdateAreasDataAction',
  }
}

export type FreeDrawLineStyleActionValue = {
  node: qc.Node
  newValue: {
    style: {
      lineColor: string
      lineSize: number
    }
  }
  oldValue: {
    style: {
      lineColor: string
      lineSize: number
    }
  }
}
const updateFreeDrawLineStyle = (
  node: qc.Node,
  style: {
    lineColor: string
    lineSize: number
  },
) => {
  const dlc = node.getScript(scripts.drawLine.name)
  dlc.brushColor = toQcColor(style.lineColor)
  dlc.brushSize = style.lineSize
}
export const getUpdateFreeDrawLineStyleAction = (
  value: FreeDrawLineStyleActionValue,
) => {
  return {
    value,
    execute: ({ node, newValue }: FreeDrawLineStyleActionValue) => {
      const { style } = newValue
      updateFreeDrawLineStyle(node, style)
      EventBus.$emit(Event.FREE_DRAW_LINE_STYLE_UPDATE)
    },
    undo: ({ node, oldValue }: FreeDrawLineStyleActionValue) => {
      const { style } = oldValue
      updateFreeDrawLineStyle(node, style)
      EventBus.$emit(Event.FREE_DRAW_LINE_STYLE_UPDATE)
    },
    methodName: 'getUpdateFreeDrawLineStyleAction',
  }
}
